// Pointer-drag for horizontal scroll containers (e.g. timeline, product rows).
// Touch devices already pan natively, so only mouse pointers are handled.
// Dragging only engages after a small movement threshold so plain clicks on
// links inside the track keep working; a real drag suppresses the click.
const DRAG_THRESHOLD = 5;

export function initDragScroll() {
  const tracks = document.querySelectorAll('[data-drag-scroll]');

  tracks.forEach((track) => {
    let startX = 0;
    let startScroll = 0;
    let pressed = false;
    let dragging = false;

    track.addEventListener('pointerdown', (event) => {
      if (event.pointerType !== 'mouse') return;
      pressed = true;
      dragging = false;
      startX = event.clientX;
      startScroll = track.scrollLeft;
    });

    track.addEventListener('pointermove', (event) => {
      if (!pressed) return;
      const delta = event.clientX - startX;
      if (!dragging && Math.abs(delta) < DRAG_THRESHOLD) return;
      if (!dragging) {
        dragging = true;
        track.setPointerCapture(event.pointerId);
        track.classList.add('is-dragging');
      }
      track.scrollLeft = startScroll - delta;
    });

    const stop = () => {
      pressed = false;
      track.classList.remove('is-dragging');
    };

    track.addEventListener('pointerup', stop);
    track.addEventListener('pointercancel', stop);

    // A drag that ends on a link must not navigate.
    track.addEventListener('click', (event) => {
      if (!dragging) return;
      dragging = false;
      event.preventDefault();
      event.stopPropagation();
    }, true);
  });
}
